import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import { getVariantStyles } from './helpers';
import type { StatusChipVariant } from './types';

export interface StatusChipProps {
  text: React.ReactNode;
  variant?: StatusChipVariant;
  /**
   * Icons and colors are set by the variant, but each can be overridden with the following props.
   */
  icon?: React.ReactNode;
  iconColor?: string;
  textColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  className?: string;
  /**
   * If true, the icon will not be displayed.
   */
  hideIcon?: boolean;
}

export const StatusChip = (props: StatusChipProps) => {
  const {
    icon,
    text,
    variant = 'default',
    iconColor,
    textColor,
    backgroundColor,
    borderColor,
    className,
    hideIcon = false,
  } = props;
  const variantStyles = getVariantStyles(variant);

  // Determines whether to use the provided icon or the default icon based on the variant
  const finalIcon = hideIcon
    ? null
    : icon || <FontAwesomeIcon icon={variantStyles.icon} />;
  const finalIconColor = iconColor || variantStyles.iconColor;
  const finalTextColor = textColor || variantStyles.textColor;
  const finalBackgroundColor = backgroundColor || variantStyles.backgroundColor;
  const finalBorderColor = borderColor || variantStyles.borderColor;

  return (
    <div
      className={classNames(
        'vai-inline-flex vai-items-center vai-gap-2 vai-py-2 vai-rounded-full vai-font-medium vai-text-sm vai-whitespace-nowrap',
        finalBorderColor && 'vai-border vai-border-solid',
        finalBackgroundColor,
        finalTextColor,
        finalBorderColor,
        variant !== 'ghost' && 'vai-px-3',
        className,
      )}
    >
      {finalIcon && (
        <div
          className={classNames(
            'vai-flex vai-items-center vai-justify-center vai-w-4 vai-h-4',
            finalIconColor,
            variant === 'progress' && 'vai-animate-spin',
          )}
        >
          {finalIcon}
        </div>
      )}
      <span>{text}</span>
    </div>
  );
};
